<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-4">
          <lib-page-header-light page-title="MODALIDADES" fa-icon="folder-open"></lib-page-header-light>
        </div>
        <div class="col-md-8">
          <button [routerLink]="['/modalidades']" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-md-5">
          <div class="form-row" *ngIf="entidade.codigo">
            <div class="form-group col-md-4">
              <label class="font-weight-bold">Código TCE</label>
              <span class="form-control font-weight-bold">{{entidade.codigo}}</span>
            </div>
            <div class="form-group col-md-8">
              <button type="button" class="btn btn-link btn-sm mt-3 float-right" (click)="abrirModelo()">Modelo de
                Ata</button>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="nome" class="required">Nome</label>
              <input #nome id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4 col-sm-6">
              <label for="valor_limite">Valor limite</label>
              <input unmask="typed" [imask]="imaskConfig" formControlName="valor_limite" type="text"
                class="form-control text-right" id="valor_limite" placeholder="0,00">
            </div>
            <div class="form-group col-md-4 col-sm-6">
              <label for="prazo_limite">Prazo (dias)</label>
              <input unmask="typed" [imask]="imaskQtd" formControlName="prazo_limite" type="text"
                class="form-control text-right" id="prazo_limite">
            </div>
            <div class="form-group col-md-4 col-sm-6">
              <label>Total Licitações</label>
              <span class="form-control text-right font-weight-bold text-primary">
                {{+totalModalidade | number:'1.2-2'}}
              </span>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="col-12">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <div class="checkbox checbox-switch switch-danger">
                    <label class="mb-0">
                      <input type="checkbox" formControlName="exigir_licitacao" /><span></span>Exigir licitação
                    </label>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="checkbox checbox-switch switch-danger">
                    <label class="mb-0">
                      <input type="checkbox" formControlName="exigir_contrato" /><span></span>Exigir contrato
                    </label>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="checkbox checbox-switch switch-danger">
                    <label class="mb-0">
                      <input type="checkbox" formControlName="exigir_convenio" /><span></span>Exigir convênio
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="offset-md-1 col-md-6 card pt-2">
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-eddy">
                  <tbody>
                    <tr *ngFor="let item of listaTiposContratacao">
                      <td class="text-center">
                        <div class="checkbox checbox-switch switch-primary" style="text-align: right;">
                          <label style="margin: 0; text-align: left;">
                            <input type="checkbox" [(ngModel)]="item.marcado"
                              [ngModelOptions]="{standalone: true}" /><span></span> &nbsp;&nbsp;
                          </label>
                        </div>
                      </td>
                      <td>{{item.tipo_contratacao.tce}} - {{item.tipo_contratacao.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<lib-modelo-ata-dlg [modelo]="entidade?.modelo_ata" (callback)="callbackModelo($event)"></lib-modelo-ata-dlg>